/* Clone a date */
export const cloneDate = (date: Date) => new Date(date.valueOf())
